export const notificationsKey = 'notifications';
export const notificationsCountKey = 'notificationsCountKey';
